import * as React from 'react';
import { DataTableChip, EXTRA_SMALL_ICON_BASE_SRC } from '../../../../Shared/index';

interface flaggedStudentsProps {
  flaggedStudents: Object,
  students: Object,
  toggleStudentFlag: Function
}

interface flaggedStudentsState {
  showUnflaggedStudents: boolean
}

class FlaggedStudents extends React.Component<flaggedStudentsProps, flaggedStudentsState> {
  constructor(props) {
    super(props);
    this.state = { showUnflaggedStudents: false };
    this.toggleShowUnflaggedStudents = this.toggleShowUnflaggedStudents.bind(this);
  }

  toggleShowUnflaggedStudents() {
    this.setState({ showUnflaggedStudents: !this.state.showUnflaggedStudents });
  }

  renderFlagButton(studentKey: string) {
    const isFlagged = !!(this.props.flaggedStudents && this.props.flaggedStudents[studentKey]);
    const studentName = this.props.students[studentKey];
    return (
      <button
        aria-label={`${isFlagged ? 'Unflag' : 'Flag'} ${studentName}`}
        className={`quill-button extra-small focus-on-light ${isFlagged ? 'contained green' : 'outlined green'}`}
        onClick={() => this.props.toggleStudentFlag(studentKey)}
        type="button"
      >
        {isFlagged ? 'Unflag' : 'Flag'}
      </button>
    );
  }

  renderStudentRow(asId: string) {
    const name = this.props.students[asId];
    const accountImg = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/account.svg`} />;
    return (
      <tr key={asId}>
        <td>{this.renderFlagButton(asId)}</td>
        <td>
          <DataTableChip color="grey" icon={accountImg} label={name} />
        </td>
      </tr>
    );
  }

  renderRows() {
    const { students, flaggedStudents } = this.props;
    const { showUnflaggedStudents } = this.state;

    if (showUnflaggedStudents) {
      return Object.keys(students).map(id => this.renderStudentRow(id));
    }

    const flaggedIds = flaggedStudents ? Object.keys(flaggedStudents) : [];
    return flaggedIds.map(id => this.renderStudentRow(id));
  }

  render() {
    const { flaggedStudents } = this.props;
    const { showUnflaggedStudents } = this.state;
    const studLength = flaggedStudents ? Object.keys(flaggedStudents).length : 0;
    const studSuffix = studLength === 1 ? '' : 's';
    const toggleLabel = showUnflaggedStudents ? 'Hide Unflagged Students' : 'Show Unflagged Students';
    const bodyVisible = showUnflaggedStudents || studLength > 0;

    return (
      <div className="flagged-student-list-container">
        <div className={`flagged-list-header${bodyVisible ? '' : ' no-body'}`}>
          <span>You have flagged <strong>{studLength} student{studSuffix}</strong></span>
          <button
            className="quill-button contained small green focus-on-light"
            onClick={this.toggleShowUnflaggedStudents}
            type="button"
          >
            {toggleLabel}
          </button>
        </div>
        {bodyVisible && (
          <div className="flagged-list-body">
            <div className="flagged-list-table-wrapper">
              <table>
                <thead>
                  <tr>
                    <th>Flag</th>
                    <th>Student</th>
                  </tr>
                </thead>
                <tbody>
                  {this.renderRows()}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default FlaggedStudents;
